import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/zone/main.png';
const _withScopeId = n => (_pushScopeId("data-v-7ef60656"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "wrap wrap-top"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0
})], -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "wrap wrap-why"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "wrap wrap-plan"
};
const _hoisted_9 = {
  class: "desc"
};
const _hoisted_10 = {
  class: "per"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  class: "desc"
};
const _hoisted_13 = {
  class: "per"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "desc"
};
const _hoisted_16 = {
  class: "per"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  class: "sales"
};
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'Zone',
  setup(__props) {
    const {
      t
    } = useI18n();
    onMounted(() => {
      document.documentElement.scrollTop = 0;
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('zone.top.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('zone.top.desc')), 1), _createVNode(_component_router_link, {
        to: "/contact"
      }, {
        default: _withCtx(() => [_createElementVNode("button", null, _toDisplayString(_unref(t)('zone.top.btn')), 1)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('zone.feature.title')), 1), _createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, i => {
        return _createElementVNode("li", null, [_createElementVNode("img", {
          src: require(`@/assets/imgs/zone/${i - 1}.png`),
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("h3", null, _toDisplayString(_unref(t)(`zone.feature.list[${i - 1}].title`)), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)(`zone.feature.list[${i - 1}].desc`)), 1)]);
      }), 64))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('zone.plan.title')), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("h3", null, _toDisplayString(_unref(t)(`zone.plan.essential.name`)), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)(`zone.plan.essential.desc`)), 1), _createElementVNode("h2", null, _toDisplayString(_unref(t)(`zone.plan.essential.price`)), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)(`zone.plan.per`)), 1), _createVNode(_component_router_link, {
        to: "/contact"
      }, {
        default: _withCtx(() => [_createElementVNode("button", null, _toDisplayString(_unref(t)(`zone.plan.btn`)), 1)]),
        _: 1
      }), _createElementVNode("ol", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
        return _createElementVNode("li", {
          innerHTML: _unref(t)(`zone.plan.essential.list[${i - 1}]`)
        }, null, 8, _hoisted_11);
      }), 64))])]), _createElementVNode("li", null, [_createElementVNode("h3", null, _toDisplayString(_unref(t)(`zone.plan.professional.name`)), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)(`zone.plan.professional.desc`)), 1), _createElementVNode("h2", null, _toDisplayString(_unref(t)(`zone.plan.professional.price`)), 1), _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)(`zone.plan.per`)), 1), _createVNode(_component_router_link, {
        to: "/contact"
      }, {
        default: _withCtx(() => [_createElementVNode("button", null, _toDisplayString(_unref(t)(`zone.plan.btn`)), 1)]),
        _: 1
      }), _createElementVNode("ol", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
        return _createElementVNode("li", {
          innerHTML: _unref(t)(`zone.plan.professional.list[${i - 1}]`)
        }, null, 8, _hoisted_14);
      }), 64))])]), _createElementVNode("li", null, [_createElementVNode("h3", null, _toDisplayString(_unref(t)(`zone.plan.advanced.name`)), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)(`zone.plan.advanced.desc`)), 1), _createElementVNode("h2", null, _toDisplayString(_unref(t)(`zone.plan.advanced.price`)), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)(`zone.plan.per`)), 1), _createVNode(_component_router_link, {
        to: "/contact"
      }, {
        default: _withCtx(() => [_createElementVNode("button", null, _toDisplayString(_unref(t)(`zone.plan.btn`)), 1)]),
        _: 1
      }), _createElementVNode("ol", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, i => {
        return _createElementVNode("li", {
          innerHTML: _unref(t)(`zone.plan.advanced.list[${i - 1}]`)
        }, null, 8, _hoisted_17);
      }), 64))])])]), _createVNode(_component_router_link, {
        to: "/contact"
      }, {
        default: _withCtx(() => [_createElementVNode("button", _hoisted_18, _toDisplayString(_unref(t)('zone.plan.btn')), 1)]),
        _: 1
      })])]);
    };
  }
});